import { render } from "./BrandCard.vue?vue&type=template&id=671bd558&scoped=true"
import script from "./BrandCard.vue?vue&type=script&lang=js"
export * from "./BrandCard.vue?vue&type=script&lang=js"

import "./BrandCard.vue?vue&type=style&index=0&id=671bd558&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671bd558"]])

export default __exports__